import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import ReactDOM from "react-dom";

import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { Actions as LEAVEACTIONS } from "../../store/actions/leaveActions";
import { Actions as REPORTACTIONS } from "../../store/actions/reportActions";

import DatePicker from "react-datepicker";
import { TimeInputFormat, DateInputFormat } from "@/common/DateComponents";
import { createRequest } from "@/common/helpers/RequestHelpers";

import {
	add,
	addDays,
	addMonths,
	addYears,
	differenceInDays,
	endOfMonth,
	format,
	intervalToDuration,
	isAfter,
	set,
	sub,
	subYears,
	subMonths,
} from "date-fns";
// import { addDays, subMonths, addYears, subYears } from 'date-fns';

import { connect } from "react-redux";
import ReportPayPeriodModal from "./ReportPayPeriodModal";

import apiURL from "../../store/actions/apiURL";
import { ChevronDownIcon, DocumentArrowDownIcon, PencilSquareIcon, StarIcon } from "@heroicons/react/20/solid";
// import outline star icon
import { StarIcon as StarOutline } from "@heroicons/react/24/outline";
import { orderBy } from "lodash";
import ReportRow from "./ReportRow";

import Select from "react-select";
import { Actions as FSS_ACTIONS } from "@/redux/actions/fssReportActions";
import { Actions as PAYROLL_ACTIONS } from "@/redux/actions/payrollActions";
import { Actions as COMPANY_ACTIONS } from "@/redux/actions/companyActions";
import { useMemo } from "react";
import { NotificationManager } from "react-notifications";

const reportRequest = createRequest({
	urlPath: "/report",
	local: false,
});

const ReportPage = ({
	updateReportFilters,
	departments,
	org,
	showLeaveBalanceReportModal,
	employeesGetList,
	departmentOptions,
	timesheetGet,
	employeeOptions,
	workLocationOptions,
	employeesGetListWithSalary,
	employees,
	settingsPermissions,
	getWorkLocationSettings,
	processing,
	userPermissions,
	getMyPermissions,
	archivedStatus,
	companyJurisdiction,
	advisorJurisdiction,
	hasDepartments,
	paySchedules,
	payPeriods,
	reportPacks,
	favouritedReportPack,
	advisorCustomReports,

	startDate,
	endDate,
	checkGroupBy,
	totalsOnly,
	selectedDepartment,
	selectedEmploymentType,
	selectedPeriod,
	concludePayroll,
	downloadEmployeeForm,
	downloadAllPayslips,
	downloadReport,
	setBankTransferPeriod,
	setBankTransferModal,
	saveReportPacks,
	saveFavouritedReports,
	getFavouritedReports,
	getReportPacks,

	isAdvisor,
	isAdvisorOfCompany,
	hasAdvisor,
}) => {
	const { id } = useParams();

	const [reports, setReports] = useState([]);
	const [showAllReports, setShowAllReports] = useState([]);
	const [favouritedReports, setFavouritedReports] = useState([]);
	const [jurisdiction, setJurisdiction] = useState(isAdvisor ? advisorJurisdiction : companyJurisdiction);

	/** move some of these options into redux so they can be shared with other components */
	const [selectedEmployee, setSelectedEmployee] = useState();
	const [selectedWorkLocation, setSelectedWorkLocation] = useState();
	const [selectedStatus, setSelectedStatus] = useState();

	const fixedReports = [
		{
			id: "LeaveSituationReport",
			name: "Leave Situation Report",
			reportGroup: "Leave",
			supportedFileTypes: ["link"],
			method: "page",
			path: "/leave/applications",
			company: "0",
			onClick: (e) => {
				showLeaveBalanceReportModal();
			},
		},
		{
			id: "DetailedLeaveReport",
			name: "Detailed Leave Report",
			reportGroup: "Leave",
			supportedFileTypes: ["link"],
			method: "page",
			path: `/leave/applications`,
			company: "0",
		},

		{
			// "icon": DocumentDuplicateIcon,
			id: "PayrollReport",
			name: "Payroll Report",
			reportGroup: "Pay Period",
			supportedFileTypes: ["pdf"],
			requiredFilters: ["companyPayPeriod"],
			company: "0",
			onClick: (e, { companyPayPeriod }) => downloadReport("payroll", companyPayPeriod),
		},
		{
			// "icon": DocumentDuplicateIcon,
			id: "PayrollChangeReport",
			name: "Payroll Change Report",
			reportGroup: "Pay Period",
			supportedFileTypes: ["pdf"],
			requiredFilters: ["companyPayPeriod"],
			company: "0",
			onClick: (e, { companyPayPeriod }) => downloadReport("payrollChange", companyPayPeriod),
		},
		{
			// "icon": DocumentDuplicateIcon,
			id: "BankFile",
			name: "Bank File (SEPA)",
			reportGroup: "Pay Period",
			supportedFileTypes: ["xml"],
			requiredFilters: ["companyPayPeriod"],
			jurisdiction: ["MT"],
			company: "0",
			onClick: (e, { companyPayPeriod }) => downloadReport("sepa", companyPayPeriod),
		},
		{
			// icon: DocumentDuplicateIcon,
			id: "BACS",
			name: "BACS (XML/Standard18)",
			reportGroup: "Pay Period",
			supportedFileTypes: ["xml", "txt"],
			requiredFilters: ["companyPayPeriod"],
			jurisdiction: ["UK"],
			company: "0",
			onClick: (e, { companyPayPeriod }) => downloadReport("bacs", companyPayPeriod),
		},
		{
			// "icon": DocumentIcon,
			id: "PayrollNetReport",
			name: "Payroll Net Report",
			reportGroup: "Pay Period",
			supportedFileTypes: ["pdf"],
			requiredFilters: ["companyPayPeriod"],
			company: "0",
			onClick: (e, { companyPayPeriod }) => downloadReport("net", companyPayPeriod),
		},
		{
			// "icon": CreditCardIcon,
			id: "BankNetReport",
			name: "Bank + Net Report",
			reportGroup: "Pay Period",
			supportedFileTypes: ["pdf"],
			requiredFilters: ["companyPayPeriod"],
			company: "0",
			onClick: (e, { companyPayPeriod }) => downloadReport("bank", companyPayPeriod),
		},
		{
			// "icon": BanknotesIcon,
			id: "ChequeReport",
			name: "Cheque Report",
			reportGroup: "Pay Period",
			supportedFileTypes: ["pdf"],
			requiredFilters: ["companyPayPeriod"],
			company: "0",
			onClick: (e, { companyPayPeriod }) => downloadReport("cheque", companyPayPeriod),
		},
		{
			// "icon": NewspaperIcon,
			id: "DownloadPayslips",
			name: "Download Payslips",
			reportGroup: "Pay Period",
			supportedFileTypes: ["pdf"],
			requiredFilters: ["companyPayPeriod"],
			company: "0",
			onClick: (e, { companyPayPeriod }) => downloadAllPayslips(companyPayPeriod),
		},
		{
			// "icon": BanknotesIcon,
			id: "DownloadCheques",
			name: "Download Cheques",
			reportGroup: "Pay Period",
			supportedFileTypes: ["pdf"],
			requiredFilters: ["companyPayPeriod"],
			jurisdiction: ["MT"],
			company: "0",
			onClick: (e, { companyPayPeriod }) =>
				downloadEmployeeForm({
					payPeriodID: companyPayPeriod,
					form: "Cheques",
				}),
		},
	];

	const setReportsFromReportPack = () => {
		const appliedReportPacks = reportPacks.filter((reportPack) => reportPack.appliedOrgs.includes(org));

		const newReports = (
			favouritedReportPack
				? [...favouritedReportPack, ...appliedReportPacks.flatMap((reportPack) => reportPack.reports)]
				: appliedReportPacks.flatMap((reportPack) => reportPack.reports)
		).reduce((acc, current) => {
			if (!acc.find((report) => report.id === current.id)) {
				acc.push(current);
			}
			return acc;
		}, []);

		newReports.map( r => {
			const fixedReport = fixedReports.find((fr) => fr.id === r.id);
			if (fixedReport) {
				r.onClick = fixedReport.onClick;
			}
		})

		setReports(newReports);

		if (appliedReportPacks?.length > 0) return true;
	}

	useEffect(() => {
		if (!isAdvisor && hasAdvisor) {
			if (setReportsFromReportPack()) {
				return;
			}
		}
		// set loaded right away to avoid a re-trigger
		reportRequest({
			method: "GET",
			path: "/templates",
		}).then(({ data }) => {
			// obtained data
			// console.log('data para report',data)
				if (isAdvisor) {
					data.reports = data?.reports?.filter((r) => r.company == "0");
					data.reports = [...data.reports, ...advisorCustomReports];
				} else if (favouritedReportPack) {
					// Concatenate favouritedReportPack.reports with data.reports
					data.reports = [...favouritedReportPack, ...data.reports];
				}

				const reportsMap = new Map();

				// Filter fixedReports by jurisdiction and add them to the map
				fixedReports.forEach((r) => {
					if (r.jurisdiction?.includes(jurisdiction) || !r.jurisdiction) {
						reportsMap.set(r.id, r);
					}
				});

				// Map data.reports with modifications and add them to the map, preventing duplicates
				data.reports.forEach((r) => {
					const modifiedReport = {
					...r,
					supportedFileTypes: r.supportedFileTypes ?? ["xlsx"],
					method: r.method ?? "s3Link",
					};
					// This will overwrite any existing entry with the same id, ensuring uniqueness
					reportsMap.set(r.id, modifiedReport);
				});

				const hasReportPack = reportPacks.filter((reportPack) => reportPack.appliedOrgs.includes(org))

				// Convert the map back to an array and set it as the new reports
				if (!isAdvisor && !showAllReports && hasReportPack.length == 0){
					// this is a check in case there's a delay in saving the reports and we have determined that there is a report pack
					// this should go away once moved to redux.
					return;
				}
				setReports(Array.from(reportsMap.values()));
		});
	}, [org, showAllReports, reportPacks, hasAdvisor]);

	const reportGroups = {
		"Employee": [],
		"Pay Period": [],
		"Payroll": [],
		"Leave": [],
		"Pension": [],
		"Timesheet": [],
		"Statutory": [],
	};

	reports.map((report) => {
		let reportGroup = report.reportGroup;
		if (!reportGroup) {
			switch (report.reportType) {
				case "OT Report":
				case "timesheetLeave":
				case "Contractor Pay Report":
					reportGroup = "Timesheet";
					break;
				case "Notes Report":
				case "Employee Data Row":
				case "Employee Data":
					reportGroup = "Employee";
					break;
				case "Consolidated Payroll Data":
				case "Payroll Data by Employee":
				case "Payroll Breakdown":
					reportGroup = "Payroll";
					break;
			}
		}
		if (reportGroups[reportGroup]) {
			reportGroups[reportGroup].push(report);
		} else {
			reportGroups[reportGroup] = [report];
		}

		if (["4498c949-b3bf-4e7a-9a5d-7ee14aa92d5a"].includes(report.id)) {
			report.requiredFilters = ["companyPayPeriod"];
		}
	});

	useEffect(() => {
		if (favouritedReports?.length > 0)
			return;

		if (isAdvisor || hasAdvisor){
			getReportPacks();
		} else {
			getFavouritedReports();
		}
	}, [hasAdvisor]);


	useEffect(() => {
		const favReports = (isAdvisor) ? reportPacks?.find((pack) => pack.id === id)?.reports : favouritedReportPack
		setFavouritedReports(favReports);

		if (hasAdvisor && reportPacks?.length) {
			setReportsFromReportPack()
		}

	}, [reportPacks?.length, favouritedReportPack?.length, isAdvisor, hasAdvisor]);


	// consider react-responsive-masonry instead of grid to create a masonry layout
	return (
		<div>

			{!isAdvisor && (
				<div className="row">
					<div>
						<div
							className="col-sm-3 col-xs-4"
							style={{ minHeight: "67px" }}
						>
							<label>From</label>
							<DatePicker
								selected={startDate}
								wrapperClassName="full-width"
								onChange={(date) => {
									if (!date) return;
									if (differenceInDays(endDate, date) <= 0) {
										const interval = intervalToDuration({
											start: startDate,
											end: endDate,
										});
										const newEndDate = add(date, interval);
										// setEndDate(newEndDate);
										updateReportFilters({
											startDate: date,
											endDate: newEndDate,
										});
									} else {
										updateReportFilters({
											startDate: date,
										});
									}
								}}
								showYearDropdown
								minDate={subYears(new Date(), 100)}
								maxDate={addYears(new Date(), 20)}
								dateFormat="dd/MM/yyyy"
								customInput={<DateInputFormat />}
							/>
							<div className="clearfix" />
						</div>
						<div
							className="col-sm-3 col-xs-4"
							style={{ minHeight: "67px" }}
						>
							<label htmlFor=" ">To</label>
							<DatePicker
								wrapperClassName="full-width"
								selected={endDate}
								onChange={(date) => {
									if (!date) return;
									if (differenceInDays(date, startDate) < 0) {
										const interval = intervalToDuration({
											start: endDate,
											end: startDate,
										});
										const newStartDate = sub(date, interval);
										updateReportFilters({
											endDate: date,
											startDate: newStartDate,
										});
									} else {
										updateReportFilters({
											endDate: date,
										});
									}
								}}
								showYearDropdown
								maxDate={addYears(new Date(), 20)}
								dateFormat="dd/MM/yyyy"
								customInput={<DateInputFormat />}
							/>
							<div className="clearfix" />
						</div>
						{hasDepartments ? (
							<div
								className="col-sm-3 col-xs-4"
								style={{ minHeight: "67px" }}
							>
								<label htmlFor=" ">Department</label>
								<Select
									options={departmentOptions}
									value={selectedDepartment}
									onChange={(selectedDepartment) => {
										updateReportFilters({
											department: selectedDepartment,
										});
									}}
									isClearable
								/>
								<div className="clearfix" />
							</div>
						) : null}
						{/*<div
						className="col-sm-3 col-xs-4"
						style={{ minHeight: "67px" }}
					>
						<label for=" ">Employee</label>
						<Select
							options={employeeOptions}
							value={selectedEmployee}
							onChange={setSelectedEmployee}
							isClearable
						/>
						<div className="clearfix"></div>
					</div>*/}
						{/*<div
						className="col-sm-3 col-xs-4"
						style={{ minHeight: "67px" }}
					>
						<label htmlFor="">Work Location</label>
						<Select
							options={workLocationOptions}
							value={selectedWorkLocation}
							onChange={setSelectedWorkLocation}
							isClearable
						/>
						<div className="clearfix" />
					</div>*/}
						{/*<div
						className="col-sm-3 col-xs-4"
						style={{ minHeight: "67px" }}
					>
						<label htmlFor=" ">Status</label>
						<Select
							options={statusOptions}
							value={selectedStatus}
							onChange={setSelectedStatus}
							isClearable
						/>
						<div className="clearfix" />
					</div>*/}
						<div
							className="col-sm-3 col-xs-4"
							style={{ minHeight: "67px" }}
						>
							<label htmlFor=" ">Employment Type</label>
							<Select
								options={[
									{ label: "External Contractor", value: "1843110" },
									{ label: "Part-Time", value: "502" },
									{ label: "Full-Time", value: "501" },
									{ label: "Director", value: "director" },
								]}
								value={selectedEmploymentType}
								onChange={(selected) => {
									updateReportFilters({
										employmentType: selected,
									});
								}}
								isClearable
							/>
							<div className="clearfix" />
						</div>
						{payPeriods.length ? (
							<div
								className="col-sm-3 col-xs-4"
								style={{ minHeight: "67px" }}
							>
								<label htmlFor=" ">Pay Period</label>
								<Select
									options={payPeriods}
									value={selectedPeriod}
									onChange={(selected) => {
										if (selected) {
											updateReportFilters({
												startDate: new Date(selected?.periodStart),
												endDate: new Date(selected?.periodEnd),
												period: selected,
											});
										} else {
											updateReportFilters({
												period: null,
											});
										}
									}}
									isClearable
								/>
								<div className="clearfix" />
							</div>
						) : null}

						<div
							className="col-sm-3 col-xs-4"
							style={{ minHeight: "67px" }}
						>
							<label htmlFor="totalsOnly">Show Totals Only</label>
							<label className={`css-input switch switch-sm switch-${totalsOnly ? "success" : "default"}`}>
								<input
									type="checkbox"
									name="totals"
									id="totalsOnly"
									checked={totalsOnly}
									onClick={() =>
										updateReportFilters({
											totalsOnly: !totalsOnly,
										})
									}
								/>
								<span />
							</label>
						</div>
						{hasDepartments && (
							<div
								className="col-sm-3 col-xs-4"
								style={{ minHeight: "67px" }}
							>
								<label htmlFor="groupByDepartment">Group by Department</label>
								<label
									className={`css-input switch switch-sm switch-${checkGroupBy ? "success" : "default"}`}
								>
									<input
										type="checkbox"
										name="departmentGroup"
										id="groupByDepartment"
										checked={checkGroupBy}
										onClick={() =>
											updateReportFilters({
												checkGroupBy: !checkGroupBy,
											})
										}
										disabled={!!selectedDepartment}
									/>
									<span />
								</label>
							</div>
						)}


						{ isAdvisorOfCompany ?
							<div
								className="col-sm-3 col-xs-4"
								style={{ minHeight: "67px" }}
							>
								<label htmlFor="totalsOnly">Show All Reports</label>
								<label className={`css-input switch switch-sm switch-${totalsOnly ? "success" : "default"}`}>
									<input
										type="checkbox"
										name="totals"
										id="showAllReports"
										checked={showAllReports}
										onClick={() =>
											setShowAllReports(!showAllReports)
										}
									/>
									<span />
								</label>
							</div> : ``
						}
						<div className="clearfix" />
					</div>
				</div>
			)}

			{/*<div className="row">
        {startDate && endDate && reports.map(report => {
          return(
            <ReportBtn 
              report={report} 
              key={report.id}
              enabled={true}
              startDate={startDate}
              endDate={endDate}
              checkGroupBy={checkGroupBy}
              totalsOnly={totalsOnly}
              departmentFilter={departmentFilter}
              showModalOnPress={["4498c949-b3bf-4e7a-9a5d-7ee14aa92d5a"].includes(report.id)}
            />
          )
        })}
      </div>*/}

			<div className="content">
				{reports.length > 0 && (
					<ResponsiveMasonry
						columnsCountBreakPoints={{ 350: 1, 750: 2, 1200: 3 }}
						gutter="2rem"
					>
						<Masonry
							columnsCount={2}
							gutter="2rem"
						>
							{/* <div
                        style={{
                            // borderRadius: "1rem",
                            // padding: "2rem",
                            // border: "1px solid rgb(244,244,244)",
                            // boxShadow: "1px 1px 5px 0px rgba(0,0,0,0.1)",
                            display: "grid",
                            gridTemplateColumns: "repeat(2, 1fr)",
                            gridGap: "2rem",
                        }}
                    >*/}
							{Object.keys(reportGroups)?.map((title) => {
								const reports = reportGroups[title];
								const canExpand = true;

								if (reports.length === 0) return null;

								return (
									<div
										style={{
											borderRadius: "1rem",
											// border: "1px solid rgb(244,244,244)",
											// boxShadow: "1px 1px 5px 0px rgba(0,0,0,0.1)",
											height: /*defaultToggle ? "65.42px" :*/ "auto",
										}}
									>
										<div
											style={{
												// borderBottom: "1px solid rgb(244,244,244)",
												padding: "1rem 1rem 1rem 1rem",
												borderRadius: "1rem 1rem 0rem 0rem",
												backgroundColor: /*success ? "rgb(0, 187, 135)" : */ "rgb(234,97,28)",
												fontSize: "1.5rem",
												color: "white",
												fontWeight: "bolder",
											}}
										>
											{/* Card Title Ex. Company Details */}
											{title}
											<span style={{ textAlign: "right" }}>
												{canExpand ? (
													<div style={{ float: "right" }}>
														<ChevronDownIcon
															onClick={(e) => {
																// setToggle({ ...toggle, [tag]: !toggleKey })
																// download report here??
															}}
															style={{
																height: "1.5em",
																float: "left",
																cursor: "pointer",
																transition: "transform 0.2s ease-in-out",
																userSelect: "none",
															}}
														/>
													</div>
												) : null}
											</span>
										</div>
										{false ? null : (
											<div
												style={
													{
														// height: "calc(100% - 42.42px - 36px)",
													}
												}
											>
												{orderBy(reports, "name")?.map((report, index) => {
													const updateFavouriteReports = (id, favourite) => {
														let newFavouritedReports = [...favouritedReports];

														if (favourite) {
															newFavouritedReports.push(report);
														} else {
															newFavouritedReports = newFavouritedReports.filter(
																(r) => r.id !== id,
															);
														}

														setFavouritedReports(newFavouritedReports);
														saveFavourites(newFavouritedReports);
													};

													const saveFavourites = (favouritedReports) => {
														if (!isAdvisor) return saveFavouritedReports(favouritedReports);

														if (!id)
															return NotificationManager.error(
																"Report Pack ID not found!",
																"Report Packs",
															);

														if (reportPacks?.length == 0) return console.debug("a");

														const newReportPacks = [...reportPacks];

														const reportIndex = newReportPacks?.findIndex(
															(pack) => pack.id === id,
														);
														const newReportPack = newReportPacks[reportIndex];

														if (!newReportPack || reportIndex == -1) return;

														newReportPack["reports"] = favouritedReports;
														newReportPacks[reportIndex] = newReportPack;

														saveReportPacks(newReportPacks);
													};

													const favourited = favouritedReports?.find(
														(r) => r.id === report.id,
													);

													return (
														// Checklist Ex. Company Name
														<ReportRow
															key={report.id ?? index}
															index={index}
															last={index === reports.length - 1}
															report={report}
															onClick={(tag) => {
																// updateSetupToggles(tag);
															}}
															updateFavouriteReports={updateFavouriteReports}
															favourited={favourited}
															isAdvisor={isAdvisor}
														/>
													);
												})}
											</div>
										)}
									</div>
								);
							})}
						</Masonry>
					</ResponsiveMasonry>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const employeeOptions = state?.employees?.employeeListWithSalary?.map((employee) => ({
		value: employee.id,
		label: `${employee.employeeName} ${employee.employeeSurname}`,
		salary: employee.salaries[employee.salaries.length - 1],
	}));
	const workLocationOptions = state?.workLocation?.types?.map((loc) => ({
		value: loc.id,
		label: loc.name,
	}));
	const userPermissions = state?.permissions?.my?.permissions?.timesheets;
	const settingsPermissions = state?.permissions?.my?.permissions?.settings;
	const { enableDepartments, departments } = state?.company?.settings;
	const paySchedules = state.company?.settings?.paySchedules?.map((schedule) => ({
		label: schedule.name,
		value: schedule.id,
	}));

	const { periods } = state?.payPeriods || {};

	const sortedPeriods = orderBy(
		periods?.map((payroll, i) => ({
			...(payroll || {}),
			year: Number(payroll?.year),
		})),
		["year", "period"],
		["desc", "desc"],
	);

	return {
		org: state?.company?.settings?.org,
		employeeOptions,
		workLocationOptions,
		settingsPermissions,
		departmentOptions: departments?.map((department) => ({
			label: department.departmentName || department.name,
			value: department.id,
		})),
		hasDepartments: enableDepartments === undefined ? !!departments?.length : enableDepartments,
		userPermissions,
		companyJurisdiction: state?.company?.settings?.jurisdiction,
		advisorJurisdiction: state?.advisors?.settings?.jurisdiction,
		archivedStatus: state?.company?.settings?.status,
		paySchedules,
		payPeriods:
			sortedPeriods?.map((period) => {
				console.log("period", period.paySchedule, period.periodSchedule);
				const { periodStart, periodEnd, paySchedule: periodSchedule, year, period: periodNo } = period || {};
				const paySchedule = paySchedules?.find((schedule) => schedule.value == periodSchedule);
				const periodOrdinal = periodNo;
				const periodDuration =
					periodStart && periodEnd
						? `${format(new Date(periodStart), "do MMM")} - ${format(new Date(periodEnd), "do MMM")}`
						: "";
				const title = `${periodOrdinal} ${paySchedule?.label} Payroll ${year} (${periodDuration})`;

				return {
					label: title,
					value: period.id,
					periodStart,
					periodEnd,
				};
			}) ?? [],

		selectedDepartment: state?.report?.filters?.department,
		startDate: state?.report?.filters?.startDate,
		endDate: state?.report?.filters?.endDate,
		checkGroupBy: state?.report?.filters?.checkGroupBy,
		totalsOnly: state?.report?.filters?.totalsOnly,
		selectedEmploymentType: state?.report?.filters?.employmentType,
		selectedPeriod: state?.report?.filters?.period,
		reportPacks: state?.advisors?.reports?.reportPacks || [],
		favouritedReportPack: state?.company?.favouritedReports || [],
		advisorCustomReports: state?.advisors?.reports?.customReports || [],
		hasAdvisor: state?.company?.settings?.advisor || false,
		isAdvisorOfCompany: state?.my?.profile?.isAdvisorOf, // == state?.company?.settings?.advisor,
	};
};

const mapDispatchToProps = (dispatch) => ({
	// selectEmployee: (employee, selected) => dispatch(TIMESHEETIMPORTACTIONS.selectEmployee(employee, selected))
	showLeaveBalanceReportModal: () => dispatch(LEAVEACTIONS.showLeaveBalanceReportModal(true)),
	updateReportFilters: (options) => dispatch(REPORTACTIONS.updateReportFilters(options)),

	// sendPayPeriodToXero: (id) => dispatch(PAYROLL_ACTIONS.sendPayPeriodToXero(id)),
	concludePayroll: (id) => dispatch(PAYROLL_ACTIONS.concludePayroll({ id })),
	downloadAllPayslips: (id) => dispatch(PAYROLL_ACTIONS.downloadAllPayslips(id)),
	downloadEmployeeForm: (data) => dispatch(FSS_ACTIONS.downloadEmployeeForm(data)),
	// payrollUpdateId: (id) => dispatch(PAYROLL_ACTIONS.payrollUpdateId(id)),
	downloadReport: (reportType, payPeriods, year, period) =>
		dispatch(PAYROLL_ACTIONS.downloadReport(reportType, payPeriods, year, period)),
	setBankTransferPeriod: (period) => dispatch(COMPANY_ACTIONS.setBankTransferPeriod(period)),
	setBankTransferModal: () => dispatch(COMPANY_ACTIONS.setBankTransferModal(true)),
	saveReportPacks: (data) => dispatch(REPORTACTIONS.postReportPacks(data)),
	saveFavouritedReports: (data) => dispatch(REPORTACTIONS.postFavouritedReports(data)),
	getFavouritedReports: () => dispatch(REPORTACTIONS.getFavouritedReports()),
	getReportPacks: () => dispatch(REPORTACTIONS.getReportPacks()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportPage);
